import './installCompositionApi';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import VModal from 'vue-js-modal';
import VideoRoomStart from '@/components/VideoRoomStart.vue';
import vClickOutside from 'v-click-outside';
import linkify from 'vue-linkify';
import mdiVue from 'mdi-vue/v2';
import * as mdijs from '@mdi/js';
import App from './App.vue';
import i18n from './i18n';

Vue.config.productionTip = false;

const routes = [
  { path: '/', component: VideoRoomStart },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(VModal);
Vue.use(vClickOutside);

Vue.use(mdiVue, {
  icons: mdijs,
});

Vue.directive('linkified', linkify);

new Vue({
  render: (h) => h(App),
  router,
  i18n,
}).$mount('#app');
